export const pulseFormControlOverrides = {
  Label: {
    style: ({ $theme }) => ({
      fontSize: '13px',
      fontWeight: 500,
      lineHeight: '18px',
      color: $theme.colors.textPulseLabel,
      marginTop: 0,
      marginBottom: 0,
    }),
  },
  LabelContainer: {
    style: {
      marginTop: 0,
      marginBottom: '5px',
    },
  },
  ControlContainer: {
    style: {
      marginBottom: '12px',
    },
  },
  Caption: {
    style: ({ $theme, $error }) => ({
      fontSize: '12px',
      lineHeight: '16px',
      marginTop: '5px',
      marginBottom: 0,
      color: $error ? $theme.colors.dangerPulseText : $theme.colors.textPulseMuted,
    }),
  },
}

export const formControlOverrides = {
  Label: {
    style: ({ $theme }) => ({
      fontSize: '16px',
      lineHeight: '160%',
      color: $theme.colors.grey,
    }),
  },
}
